import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSearch,
  faStarOfLife,
  faCheck,
  faCheckCircle,
  faTimes,
  faDownload,
  faCheckDouble,
  faEye,
  faChevronCircleRight,
  faChevronCircleDown,
  faQuestionCircle,
  faPlusCircle,
  faPen,
  faEthernet,
  faLink,
  faExclamationCircle,
  faGripVertical,
  faChevronRight,
  faSun,
  faMoon,
  faLightbulb,
  faEllipsisV,
  faChartLine,
  faPlus,
  faMinus,
  faHistory,
  faImage,
  faCopy,
  faFileCsv,
  faExclamationTriangle,
  faConciergeBell,
  faNetworkWired,
  faUserShield,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  ModalPlugin,
  TabsPlugin,
  ToastPlugin,
  AlertPlugin,
  SpinnerPlugin,
  DropdownPlugin,
  NavbarPlugin,
  CardPlugin,
  SidebarPlugin,
  FormInputPlugin,
  InputGroupPlugin,
  TablePlugin,
  FormPlugin,
  FormGroupPlugin,
  FormSelectPlugin,
  FormCheckboxPlugin,
  FormDatepickerPlugin,
  FormTextareaPlugin,
  FormRadioPlugin,
  FormTagsPlugin,
  ButtonPlugin,
  BadgePlugin,
  ListGroupPlugin,
  PaginationPlugin,
} from 'bootstrap-vue'

Vue.use(AlertPlugin)
Vue.use(ModalPlugin)
Vue.use(TabsPlugin)
Vue.use(ToastPlugin)
Vue.use(SpinnerPlugin)
Vue.use(DropdownPlugin)
Vue.use(NavbarPlugin)
Vue.use(CardPlugin)
Vue.use(SidebarPlugin)
Vue.use(FormInputPlugin)
Vue.use(InputGroupPlugin)
Vue.use(TablePlugin)
Vue.use(FormPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormRadioPlugin)
Vue.use(ButtonPlugin)
Vue.use(BadgePlugin)
Vue.use(FormTagsPlugin)
Vue.use(ListGroupPlugin)
Vue.use(PaginationPlugin)

library.add(faSearch)
library.add(faStarOfLife)
library.add(faCheck)
library.add(faCheckCircle)
library.add(faTimes)
library.add(faDownload)
library.add(faCheckDouble)
library.add(faEye)
library.add(faChevronCircleRight)
library.add(faChevronCircleDown)
library.add(faQuestionCircle)
library.add(faPen)
library.add(faPlusCircle)
library.add(faEthernet)
library.add(faLink)
library.add(faExclamationCircle)
library.add(faGripVertical)
library.add(faChevronRight)
library.add(faSun)
library.add(faMoon)
library.add(faLightbulb)
library.add(faEllipsisV)
library.add(faChartLine)
library.add(faPlus)
library.add(faMinus)
library.add(faHistory)
library.add(faImage)
library.add(faCopy)
library.add(faFileCsv)
library.add(faExclamationTriangle)
library.add(faConciergeBell)
library.add(faNetworkWired)
library.add(faUserShield)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
